import React, { useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Button from "../../../ui/Button/Button";
import { getPatient } from "../../../db/users";
import "./ExtraOptions.css";

function ExtraOptions({ patientId }) {
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();

  async function optionPressed(option) {
    switch (option) {
      case "adverse":
        const response = await getPatient(
          authCtx.currentDoctor.key,
          patientId,
          authCtx.token
        );
        const clinicalInfo = response.data;
        navigate("/adverseReactions", {
          state: {
            doctor: authCtx.currentDoctor,
            clinicalInfo,
            patientId,
          },
        });
        break;
      case "abandon":
        navigate("/abandon", { state: { patientId } });
        break;
    }
  }

  return (
    <div className="extraOptions">
      <div className="extraButtonsContainer">
        <Button onPress={optionPressed.bind(this, "abandon")}>
          Cuestionario de abandono o término
        </Button>
      </div>
      <div className="extraButtonsContainer">
        <Button onPress={optionPressed.bind(this, "adverse")}>
          Reporte de reacciones adversas
        </Button>
      </div>
    </div>
  );
}

export default ExtraOptions;
